module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-width"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin": "30px 0 10px",
      "font-size": "12px",
      "color": "#bca365"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("提示：报价表最多可加入200件商品")]), _vm._v(" "), _c('div', {
    staticClass: "get-price-label",
    staticStyle: {
      "line-height": "30px",
      "display": "inline-block",
      "margin": "0",
      "height": "30px",
      "padding": "0 10px",
      "border": "none"
    },
    on: {
      "click": _vm.oneKeyDeleteGoodsMore
    }
  }, [_vm._v("\n            一键清除失效商品\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "get-price-label",
    staticStyle: {
      "line-height": "30px",
      "display": "inline-block",
      "margin": "0",
      "height": "30px",
      "padding": "0 10px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.deleteGoodsMore
    }
  }, [_vm._v("\n            批量移出报价表\n          ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading.export),
      expression: "loading.export"
    }],
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726",
      "margin-left": "20px"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.exportFn
    }
  }, [_vm._v("导出报价表")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasGoods),
      expression: "hasGoods"
    }],
    staticClass: "table-static th-eee",
    class: _vm.fixedBool == true ? 'table-fixed' : '',
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "fit": "",
      "id": "table-scroll"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "label": "全选",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "排序",
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [_c('el-input', {
          attrs: {
            "placeholder": ""
          },
          on: {
            "blur": function($event) {
              return _vm.orderNoFn(scope.row)
            }
          },
          model: {
            value: (scope.row.orderNo),
            callback: function($$v) {
              _vm.$set(scope.row, "orderNo", $$v)
            },
            expression: "scope.row.orderNo"
          }
        })] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "商品信息",
      "align": "center",
      "min-width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [_c('div', {
          staticClass: "goods-info"
        }, [_c('div', {
          staticClass: "goods-img-box"
        }, [_c('router-link', {
          attrs: {
            "tag": "a",
            "target": "_blank",
            "to": {
              name: 'Detail',
              query: {
                goodsId: scope.row.goodsVo.goodsId
              },
            }
          }
        }, [_c('div', {
          staticClass: "goods-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.goodsVo.goodsPicture
          },
          on: {
            "error": function($event) {
              return _vm.error(1)
            }
          }
        })])])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-left": "15px",
            "text-align": "left"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.goodsVo.goodsName,
            "placement": "top"
          }
        }, [_c('div', {
          staticStyle: {
            "font-size": "14px",
            "text-align": "left",
            "color": "#333",
            "display": "-webkit-box",
            "-webkit-box-orient": "vertical",
            "-webkit-line-clamp": "2",
            "overflow": "hidden"
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.goodsVo.goodsName) + "\n                  ")])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "font-size": "14px",
            "margin": "5px 0",
            "text-align": "left",
            "color": "#666"
          }
        }, [_vm._v("\n                  品牌：" + _vm._s(scope.row.goodsVo.brandName) + "\n                ")]), _vm._v(" "), _c('el-select', {
          attrs: {
            "disabled": _vm.personalitySetting.type != 3,
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.goodsVo.appType),
            callback: function($$v) {
              _vm.$set(scope.row.goodsVo, "appType", $$v)
            },
            expression: "scope.row.goodsVo.appType"
          }
        }, _vm._l((_vm.appTypeArr), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), (scope.row.goodsVo.isSelf == 1) ? _c('div', {
          staticClass: "type-icon",
          staticStyle: {
            "background-color": "rgb(231, 249, 235)",
            "color": "rgb(88, 191, 106)",
            "margin-top": "10px",
            "display": "inline-block",
            "line-height": "22px",
            "text-align": "center"
          }
        }, [_vm._v("\n                  自产自销\n                ")]) : _vm._e()], 1)])] : [_vm._v("商品失效了")]]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "规格",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [(scope.row.goodsVo.appType == 1) ? _vm._l((scope.row.goodsVo.productLabels), function(item, index) {
          return _c('div', {
            key: index,
            staticClass: "line-clamp-1"
          }, [_vm._v("\n                " + _vm._s(item.productName) + "\n              ")])
        }) : (scope.row.goodsVo.appType == 2) ? _vm._l((scope.row.goodsVo
          .communityProductLabels), function(item, index) {
          return _c('div', {
            key: index,
            staticClass: "line-clamp-1"
          }, [_vm._v("\n                " + _vm._s(item.productName) + "\n              ")])
        }) : _vm._e()] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var column = ref.column;
        var $index = ref.$index;

        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择",
            "disabled": _vm.personalitySetting.goodsTaxDisplayType != 0
          },
          model: {
            value: (_vm.piao),
            callback: function($$v) {
              _vm.piao = $$v
            },
            expression: "piao"
          }
        }, _vm._l((_vm.piaoArr), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }])
  }, [_vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "建议零售价",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [(scope.row.goodsVo.appType == 1) ? _vm._l((scope.row.goodsVo.productLabels), function(item, index) {
          return _c('div', {
            key: index
          }, [_vm._v("\n                  ￥" + _vm._s(item.salePrice / 100) + "\n                ")])
        }) : (scope.row.goodsVo.appType == 2) ? _vm._l((scope.row.goodsVo
          .communityProductLabels), function(item, index) {
          return _c('div', {
            key: index
          }, [_vm._v("\n                  ￥" + _vm._s(item.salePrice / 100) + "\n                ")])
        }) : _vm._e(), _vm._v(" "), (scope.row.priceLimit == 1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "该商品品牌方控价，请不要低于建议售价对外销售，擅自降价将会终止供应链供货。",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "price-limit-tab"
        }, [_vm._v("零售控价")])]) : _vm._e()] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "结算价（+运费）",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [(scope.row.goodsVo.appType == 1) ? _vm._l((scope.row.goodsVo.productLabels), function(item, index) {
          return _c('div', {
            key: index
          }, [(_vm.piao == 1) ? [_vm._v("\n                    ￥" + _vm._s(item.taxCooperatePrice / 100) + "(+" + _vm._s(item.fright / 100) + ")\n                  ")] : (_vm.piao == 2) ? [_vm._v("\n                    ￥" + _vm._s(item.cooperatePrice / 100) + "(+" + _vm._s(item.fright / 100) + ")\n                  ")] : _vm._e()], 2)
        }) : (scope.row.goodsVo.appType == 2) ? _vm._l((scope.row.goodsVo
          .communityProductLabels), function(item, index) {
          return _c('div', {
            key: index
          }, [(_vm.piao == 1) ? [_vm._v("\n                    ￥" + _vm._s(item.taxCooperatePrice / 100) + "\n                  ")] : (_vm.piao == 2) ? [_vm._v("\n                    ￥" + _vm._s(item.cooperatePrice / 100) + "\n                  ")] : _vm._e()], 2)
        }) : _vm._e()] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "毛利",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [(scope.row.goodsVo.appType == 1) ? _vm._l((scope.row.goodsVo.productLabels), function(item, index) {
          return _c('div', {
            key: index
          }, [(_vm.piao == 1) ? [_vm._v("\n                    ￥" + _vm._s(item.taxProfitValue / 100) + "\n                  ")] : (_vm.piao == 2) ? [_vm._v("\n                    ￥" + _vm._s(item.profitValue / 100) + "\n                  ")] : _vm._e()], 2)
        }) : (scope.row.goodsVo.appType == 2) ? _vm._l((scope.row.goodsVo
          .communityProductLabels), function(item, index) {
          return _c('div', {
            key: index
          }, [(_vm.piao == 1) ? [_vm._v("\n                    ￥" + _vm._s(item.taxProfitValue / 100) + "\n                  ")] : (_vm.piao == 2) ? [_vm._v("\n                    ￥" + _vm._s(item.profitValue / 100) + "\n                  ")] : _vm._e()], 2)
        }) : _vm._e()] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "毛利率",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [(scope.row.goodsVo.appType == 1) ? _vm._l((scope.row.goodsVo.productLabels), function(item, index) {
          return _c('div', {
            key: index
          }, [(_vm.piao == 1) ? [_vm._v("\n                    " + _vm._s(item.taxProfitMargin) + "%\n                  ")] : (_vm.piao == 2) ? [_vm._v("\n                    " + _vm._s(item.profitMargin) + "%\n                  ")] : _vm._e()], 2)
        }) : (scope.row.goodsVo.appType == 2) ? _vm._l((scope.row.goodsVo
          .communityProductLabels), function(item, index) {
          return _c('div', {
            key: index
          }, [(_vm.piao == 1) ? [_vm._v("\n                    " + _vm._s(item.taxProfitMargin) + "%\n                  ")] : (_vm.piao == 2) ? [_vm._v("\n                    " + _vm._s(item.profitMargin) + "%\n                  ")] : _vm._e()], 2)
        }) : _vm._e()] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [_c('div', {
          staticClass: "delete-btn-2",
          on: {
            "click": function($event) {
              return _vm.deleteGoods(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasGoods),
      expression: "hasGoods"
    }],
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "page-sizes": [30, 60, 100],
      "current-page": _vm.pageNum,
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.pageNum = $event
      },
      "update:current-page": function($event) {
        _vm.pageNum = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasGoods),
      expression: "!hasGoods"
    }],
    staticClass: "category-goods-wrap-no"
  }, [_c('div', {
    staticClass: "category-goods-wrap-tip"
  }, [_vm._v("没有找到相关商品...")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出提示",
      "visible": _vm.dialogVisible,
      "width": "600px",
      "show-close": false,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("导出任务正在生成，请前往【下载列表】中下载您已导出的信息")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("好的，我知道了")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible2,
      "width": "600px",
      "before-close": _vm.handleClose2,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "category-goods-add-default",
    staticStyle: {
      "width": "200px",
      "margin": "0 auto"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible2 = false
      }
    }
  }, [_vm._v("\n        我知道了\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出",
      "visible": _vm.dialogVisible3,
      "width": "600px",
      "before-close": _vm.handleClose3,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible3 = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "formDatas",
    attrs: {
      "model": _vm.formDatas,
      "rules": _vm.formRules,
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "带票类型：",
      "prop": "hasTax",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.formDatas.hasTax),
      callback: function($$v) {
        _vm.$set(_vm.formDatas, "hasTax", $$v)
      },
      expression: "formDatas.hasTax"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.personalitySetting.goodsTaxDisplayType == 2,
      "label": 2
    }
  }, [_vm._v("带票")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": _vm.personalitySetting.goodsTaxDisplayType == 1,
      "label": 1
    }
  }, [_vm._v("不带票")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "库存类型：",
      "prop": "supplyChannel",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.formDatas.supplyChannel),
      callback: function($$v) {
        _vm.$set(_vm.formDatas, "supplyChannel", $$v)
      },
      expression: "formDatas.supplyChannel"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.personalitySetting.type == 2,
      "label": 1
    }
  }, [_vm._v("一件代发")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": _vm.personalitySetting.type == 0,
      "label": 2
    }
  }, [_vm._v("社群集采")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726",
      "margin-left": "20px",
      "width": "100px"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('formDatas')
      }
    }
  }, [_vm._v("导出报价表")]), _vm._v(" "), _c('div', {
    staticClass: "get-price-label",
    staticStyle: {
      "line-height": "30px",
      "display": "inline-block",
      "margin": "0",
      "height": "30px",
      "padding": "0 10px",
      "margin-left": "20px",
      "border-color": "#ffa726",
      "color": "#ffa726",
      "width": "100px"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible3 = false
      }
    }
  }, [_vm._v("\n            取消\n          ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bccade","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PriceLibraryList.vue
// module id = 535
// module chunks = 1